import { Component, useEffect, useState } from "react";
import { keys, isEqual } from 'underscore';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import '../../../node_modules/react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import '../../../node_modules/react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter'
class PubMedLogsTable extends Component {
    constructor(props){
        super(props);
        this.state={
            data: props.data,
            columns: [],
        }
    }
     componentDidMount() {
            this.manageGridHeader(this.props.data)
        }
        componentWillReceiveProps(nextProps) {
            if (!isEqual(this.props.data, nextProps.data)) {
                this.setState({
                    data: nextProps.data
                }, () => {
                    this.manageGridHeader(nextProps.data);
                })
            }
        }

    manageGridHeader = (data) => {
            let _allKeys = keys(data[0]);
            console.log(_allKeys)
            let _columns = [];
            _allKeys.map((key) => {
                _columns.push({
                    dataField: key,
                    text: key,
                    headerFormatter: (column, val) => {
                        return (
                            <div 
                                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <label for="header" 
                                    className="pubmedAbstractsGridHeader" 
                                    title={column.dataField} 
                                    style={{ marginLeft: "7px" }}
                                >
                                    {column.dataField}
                                </label>
                            </div>
                        )
                    },
                })
            })
            this.setState({ columns: _columns });
        }
        render(){
            return(
                <>
                {(this.state.columns.length > 0 && this.state.data.length > 0) ? 
                    <ToolkitProvider
                        keyField='rowIndex'
                        data={this.state.data}
                        columns={this.state.columns}
                        >
                        {props => (
                            <div>
                                {/* <div className="admin-data-function-button-wrapper">
                                    <div className="admin-heading-leftPart">
                                        <span className="admin-console-heading"></span>
                                    </div>
                                    <div className="admin-console-button-container">
                                        <Button text="View Details" isDisabled={!(this.state.selected && this.state.selected.length === 1)} customColor='#2EB000' action={this.handleButtonViewDetails} />
                                    </div>
                                </div> */}
                                <BootstrapTable
                                    {...props.baseProps}
                                    bordered={false}
                                    // pagination={paginationFactory(options)}
                                    wrapperClasses="table-responsive adminconsole-table"
                                    classes="adminDashboard-table table-bordered"
                                    rowClasses="text-nowrap"
                                >
                                </BootstrapTable>
                            </div>
                        )}
                    </ToolkitProvider> 
                    : 
                <div>
                </div>
            }</>
            )
        }

}
export default PubMedLogsTable;